import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="px-4 md:px-10 lg:px-20 py-12 max-w-4xl mx-auto text-gray-800">
      {/* Page Title */}
      <h1 className="text-4xl font-bold mb-8 text-left">Terms and Conditions</h1>

      {/* Intro */}
      <p className="mb-6 text-left leading-relaxed">
        Welcome to <strong>Daily Go</strong>. By accessing or using our website, platform, 
        or services, you agree to comply with and be bound by the following Terms and Conditions. 
        Please review them carefully before proceeding.
      </p>

      {/* Section 1 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">1. Acceptance of Terms</h2>
        <p className="text-left leading-relaxed">
          By using our website or services, you confirm that you accept these Terms and Conditions 
          and agree to abide by them. If you do not agree, please discontinue use immediately.
        </p>
      </section>

      {/* Section 2 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">2. Use of Services</h2>
        <ul className="list-disc ml-6 text-left leading-relaxed space-y-2">
          <li>You agree to use our platform only for lawful and appropriate purposes.</li>
          <li>You must not attempt to disrupt or misuse the website, platform, or related services.</li>
          <li>We reserve the right to restrict or terminate access if any misuse is detected.</li>
        </ul>
      </section>

      {/* Section 3 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">3. Intellectual Property</h2>
        <p className="text-left leading-relaxed">
          All content, branding, and materials available on <strong>Daily Go</strong> 
          are owned or licensed by us unless otherwise stated. Unauthorized use, reproduction, 
          or distribution of our content is strictly prohibited without prior written consent.
        </p>
      </section>

      {/* Section 4 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">4. Limitation of Liability</h2>
        <p className="text-left leading-relaxed">
          While we make every effort to provide accurate and reliable information, 
          <strong> Daily Go </strong> shall not be held liable for any direct, indirect, 
          or consequential damages arising from the use or inability to use our services.
        </p>
      </section>

      {/* Section 5 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">5. Third-Party Links</h2>
        <p className="text-left leading-relaxed">
          Our platform may include links to external websites or services. 
          We are not responsible for the content, availability, or privacy practices 
          of third-party sites. Please review their policies before engaging with them.
        </p>
      </section>

      {/* Section 6 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">6. Termination of Access</h2>
        <p className="text-left leading-relaxed">
          We may suspend or terminate your access to <strong>Daily Go</strong> at any time, 
          without notice, if we believe you have violated these Terms and Conditions.
        </p>
      </section>

      {/* Section 7 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-2 text-left">7. Changes to Terms</h2>
        <p className="text-left leading-relaxed">
          We may update these Terms and Conditions from time to time. 
          Any changes will be effective once posted on this page. 
          Continued use of our services indicates acceptance of the revised terms.
        </p>
      </section>

      {/* Section 8 */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2 text-left">8. Contact Us</h2>
        <p className="text-left leading-relaxed">
          If you have any questions or concerns regarding these Terms and Conditions, 
          please reach out to us at:{" "}
          <a 
            href="mailto:office-info@dailygolive.in " 
            className="text-blue-600 underline hover:text-blue-800"
          >
            office-info@dailygolive.in
          </a>.
        </p>
      </section>

      {/* Footer Note */}
      <p className="text-sm text-gray-500 text-left">
        Last updated: <span className="font-medium">August 2025</span>
      </p>
    </div>
  );
};

export default TermsAndConditions;
